import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
export interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps {
  options: SelectOption[];
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  label?: string;
}
export function Select({
  options,
  value,
  onChange,
  placeholder = 'Select option',
  className,
  label
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const selectedOption = options.find(opt => opt.value === value);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="w-full space-y-1.5" ref={containerRef} data-id="element-397">
      {label && <label className="text-xs font-medium text-white block" data-id="element-398">{label}</label>}
      <div className="relative" data-id="element-399">
        <button type="button" onClick={() => setIsOpen(!isOpen)} className={cn('flex h-10 w-full items-center justify-between rounded-md border bg-[#1A1A2E] px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent/20 transition-all duration-200', isOpen ? 'border-accent ring-2 ring-accent/20' : 'border-primary', className)} data-id="element-400">
          <span className={cn('truncate', !selectedOption && 'text-gray-500')} data-id="element-401">
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <ChevronDown className={cn('h-4 w-4 opacity-50 transition-transform', isOpen && 'rotate-180')} data-id="element-402" />
        </button>

        {isOpen && <div className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md border border-primary bg-[#1A1A2E] py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none animate-in fade-in-0 zoom-in-95" data-id="element-403">
            {options.map(option => <button key={option.value} type="button" onClick={() => {
          onChange(option.value);
          setIsOpen(false);
        }} className={cn('relative flex w-full cursor-pointer select-none items-center py-1.5 pl-3 pr-9 text-sm outline-none hover:bg-primary/10 hover:text-primary transition-colors', value === option.value && 'bg-primary/20 text-primary font-medium')} data-id="element-404">
                <span className="block truncate" data-id="element-405">{option.label}</span>
              </button>)}
          </div>}
      </div>
    </div>;
}